module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4dqtB"))).then(() => module.bundle.root('cvs7o'));